import { useTranslation } from 'react-i18next'

import { ComboBox, RadioGroup, trackingStatusLabels } from '@reveni-io/reveni-ui'

import {
  scenarioReturnedOptions,
  scenarioReturnedValues,
} from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/hooks/useCustomScenario/constants'
import { getScenarioOptions } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/PreviewSettingsSidebar/CustomScenarioSettings/helpers'
import ScenarioCard from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/PreviewSettingsSidebar/CustomScenarioSettings/ScenarioCard/ScenarioCard'

const ScenarioItemCard = ({ item, position, onChange, onRemove }) => {
  const { t } = useTranslation()

  const returnedOptions = scenarioReturnedOptions.map(option => ({ value: option.value, label: t(option.label) }))
  const returnedValue = item.returned ? scenarioReturnedValues.yes : scenarioReturnedValues.no
  const statusOptions = getScenarioOptions(trackingStatusLabels, t)

  const handleChangeReturned = event => {
    onChange(item.id, { returned: event.target.value === scenarioReturnedValues.yes })
  }

  const handleChangeStatus = event => onChange(item.id, { status: event.target.value })

  const handleRemove = () => onRemove(item.id)

  return (
    <ScenarioCard
      title={t('Artículo #{{number}}', { number: position })}
      removeLabel={t('Eliminar artículo #{{number}}', { number: position })}
      testId={`scenario-item-${position}`}
      onRemove={handleRemove}
    >
      <RadioGroup
        label={t('¿Se ha devuelto?')}
        name={`scenario-item-${item.id}-returned`}
        options={returnedOptions}
        value={returnedValue}
        orientation="row"
        onChange={handleChangeReturned}
      />
      <ComboBox
        fullWidth
        label={t('Estado del artículo #{{number}}', { number: position })}
        menuItems={statusOptions}
        value={item.status}
        handleChange={handleChangeStatus}
      />
    </ScenarioCard>
  )
}

export default ScenarioItemCard
